import {
  AfterViewInit,
  Component,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {get} from "lodash-es";
import { runtimeEventManager } from '@wm/core';

const DEFAULT_CLS = 'app-fileupload';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-fileupload',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmFileupload]',
  template: `<div class="app-fileupload">
    <!-- drag and drop files UI in web -->
    <div class="app-multi-file-upload" *ngIf="!_isMobileType && multiple">
      <div id="dropzone" class="drop-box" [ngClass]="{'highlight-drop-box' : highlightDropArea}">
        <i class="{{iconclass}}"></i>
        <div class="message">
          <label [innerHtml]="caption" class="caption"></label>
          <form class="form-horizontal" name="{{formName}}">
            <input class="file-input" [attr.aria-label]="hint || 'File selection field'" type="file" name="files" *ngIf="multiple" [disabled]="disabled" [accept]="chooseFilter" multiple >
            <a href="javascript:void(0);" class="app-anchor">{{fileUploadMessage}}</a>
          </form>
        </div>
      </div>
    </div>
    <!-- single file upload in web and single , multiple file upload UI in mobile runmode -->
    <div class="app-single-file-upload" *ngIf="!_isCordova && (!multiple || _isMobileType)">
      <div class="app-button-wrapper">
        <form class="form-horizontal" name="{{formName}}">
          <!-- support for file upload in Mobileapp in its runmode (Web) -->
          <input class="file-input" [attr.aria-label]="hint || 'File selection field'" type="file" name="files" *ngIf="multiple" [disabled]="disabled" [accept]="chooseFilter" multiple>
          <input class="file-input" [attr.aria-label]="hint || 'File selection field'" type="file" name="files" *ngIf="!multiple" [disabled]="disabled" [accept]="chooseFilter" >
          <button id="dropzone" focus-target class="app-button btn btn-default" [ngClass]="{'highlight-drop-box' : highlightDropArea}">
            <i class="{{iconclass}}" aria-hidden="true"></i>
            <span class="caption" [innerHTML]="caption"></span>
          </button>
        </form>
      </div>
      <div class="app-files-upload-status single"></div>
    </div>
  </div>`,
  providers: [
    provideAsWidgetRef(FileuploadComponent)
  ],
  exportAs: 'wmFileupload',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class FileuploadComponent extends StylableComponent implements AfterViewInit{
  static initializeProps = register('wm-fileupload');

  selectedFiles: any = [];
  selectedFolders: any = [];
  name: string;
  hint: string;
  multiple: any;
  caption = 'Upload';
  formName = '';
  maxfilesize: number;
  cleariconclass: string;
  cleariconhint: string;
  iconclass: string;
  disabled: boolean;
  _isMobileType: any = false; // TODO: get this type from projectSettings
  _isCordova: any;
  chooseFilter = '';
  datasource: any;
  fileUploadMessage = 'Drop your files here or click here to browse';
  service: any;
  operation: any;
  private variableService: any;

  highlightDropArea: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    this.variableService = runtimeEventManager.getService('variableService');
  }


  override ngAfterViewInit() {
    styler(this.nativeElement, this);
  }


  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('div.drop-box') || this.nativeElement.querySelector('button.app-button') || this.nativeElement;
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'fileuploadmessage'){
      this.fileUploadMessage = nv;
    }else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  /**
   * Returns the data-type for properties in the widget.
   * For 'uploadedFiles', the type is dependent on the Variable against the service and operation selected
   * @param prop
   * @returns {*}
   */
  getPropertyType(prop: any,types: any) {
    let variable: any, type;
    switch (prop) {
      case 'uploadedFiles':
        variable = this.variableService.filterByVariableKeys({ 'service': this.service, 'operation': this.operation, 'category': 'wm.ServiceVariable' }, true)[0];
        type = variable && variable.type;
        break;
      case 'selectedFiles':
        type = this.widgetType + '_' + prop;
        types[type] = {
          'fields': {
            'name': {
              'type': 'string'
            },
            'size': {
              'type': 'number'
            },
            'type': {
              'type': 'string'
            }
          }
        };
        // if (this.isMobileApplicationType) {
        //   types[type].fields['content'] = {
        //     'type': 'file'
        //   };
        // }
        break;
    }
    return type;
  }

}

